var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.588 14.5821C34.588 20.4562 29.8782 25.1662 24 25.1662C18.1238 25.1662 13.412 20.4562 13.412 14.5821C13.412 8.70805 18.1238 4 24 4C29.8782 4 34.588 8.70805 34.588 14.5821ZM24 44C15.3247 44 8 42.59 8 37.1499C8 31.7079 15.3708 30.3479 24 30.3479C32.6773 30.3479 40 31.7579 40 37.1979C40 42.64 32.6292 44 24 44Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.ee9e86f43c58e6ca7e7054a3958b787f.svg";
export { ForwardRef as ReactComponent };